import React, { forwardRef, memo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

const CardComponent = forwardRef(
  ({ as: Tag = 'div', className, title, actions, flush = false, children, ...rest }, ref) => (
    <Tag {...rest} ref={ref} className={classNames(style.host, { [style.flush]: flush }, className)}>
      {(title || actions) && (
        <div className={style.header}>
          {title && <div className={style.title}>{title}</div>}
          {actions && <div className={style.actions}>{actions}</div>}
        </div>
      )}
      {children}
    </Tag>
  ),
);

CardComponent.displayName = 'Card';

/**
 * Surface card: the base block of every page widget.
 *
 * @param props.as Rendered tag, e.g. 'section' or 'form'.
 * @param props.title Optional uppercase title shown in the header row.
 * @param props.actions Optional controls aligned to the right of the header row.
 * @param props.flush Removes the inner padding, for content that runs edge to edge (tables).
 */
export const Card = memo(CardComponent);
